// ACTIONS
export const FETCH = 'offerzen/skills/FETCH'
const FETCH_SUCCESS = 'offerzen/skills/FETCH_SUCCESS'
const FETCH_ERROR = 'offerzen/skills/FETCH_ERROR'

export const SEARCH = 'offerzen/skills/SEARCH'
const SEARCH_SUCCESS = 'offerzen/skills/SEARCH_SUCCESS'
const SEARCH_ERROR = 'offerzen/skills/SEARCH_ERROR'

export const UPDATE = 'offerzen/skills/UPDATE'
const UPDATE_SUCCESS = 'offerzen/skills/UPDATE_SUCCESS'
const UPDATE_ERROR = 'offerzen/skills/UPDATE_ERROR'

// ACTION CREATORS
export const fetchSkills = id => ({
  type: FETCH,
  payload: {
    loading: true,
    id,
  },
})

export const fetchSkillsSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: {
    loading: false,
    data,
  },
})

export const fetchSkillsError = errorMessage => ({
  type: FETCH_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const searchSkills = text => ({
  type: SEARCH,
  payload: {
    searching: true,
    text,
  },
})

export const searchSkillsSuccess = data => ({
  type: SEARCH_SUCCESS,
  payload: {
    searching: false,
    data,
  },
})

export const searchSkillsError = errorMessage => ({
  type: SEARCH_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const updateSkills = (id, data, resolve, reject) => ({
  type: UPDATE,
  meta: { resolve, reject },
  payload: {
    loading: true,
    id,
    data,
  },
})

export const updateSkillsSuccess = data => ({
  type: UPDATE_SUCCESS,
  payload: {
    loading: false,
    data,
  },
})

export const updateSkillsError = errorMessage => ({
  type: UPDATE_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

const initialState = {
  editing: false,
  loading: false,
  searching: false,
  error: null,
  data: [],
  searchResults: [],
}

// REDUCERS
const skillsReducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case FETCH:
      return {
        ...state,
        loading: payload.loading,
      }

    case SEARCH:
      return {
        ...state,
        searching: payload.searching,
      }

    case FETCH_SUCCESS:
    case UPDATE_SUCCESS:
      return {
        ...state,
        loading: payload.loading,
        data: payload.data,
      }

    case SEARCH_SUCCESS:
      return {
        ...state,
        searching: payload.searching,
        searchResults: payload.data,
      }

    case FETCH_ERROR:
    case UPDATE_ERROR:
    case SEARCH_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      }

    default:
      return state
  }
}

export default skillsReducer

export const getSkills = state => state.skills || initialState
